import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-page-childs-menu',
  templateUrl: './app-page-childs-menu.component.html',
  styleUrls: ['./app-page-childs-menu.component.css']
})

export class AppPageChildsMenuComponent implements OnInit {

  @Input() childs;
  @Input() selectedMenuId;
  @Output() onRadioSelected = new EventEmitter<number>();

  ngOnInit() {}

  updateMenuId(value){
    this.onRadioSelected.emit(+value);
  }
}

